import React from 'react'

import InfiniteScroll from "react-infinite-scroll-component";

import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

var tracery = require('tracery-grammar');

const grammarDE = {
"PREDTRANSPLUR":["sprechen", "lehren", "lesen"],
"SPINTRANS":["#SUBJEKTSING# #PREDINTRANSSING#", "#SUBJEKTPLUR# #PREDINTRANSPLUR#"],
"SATZ4":["wenn #CONDSATZ#, dann #CONDSATZ2#"],
"START1a":["#SATZ1#", "#SATZ2#", "#SATZ3#", "#SATZ4#"],
"PREFIXQ":["soll ich sagen:", "heißt das nun:", "ist es falsch, zu sagen:"],
"FRAGEPREFIX":["man möchte fragen:", "frage:"],
"SATZ3":["#SATZ1o2#, #CONJ# #CONDSATZ#"],
"SUBJEKTSING1ADJ":["#ARTIKELSINGN# #ADJSINGDET# #SUBJEKTSING1N#", "#ARTIKELSINGM# #ADJSINGDET# #SUBJEKTSING1M#", "#ARTIKELSINGW# #ADJSINGDET# #SUBJEKTSING1W#"],
"GENITIVSING":["der #SUBJEKTSING1W#", "des #GENITIVSING1M#", "des #GENITIVSING1N#"],
"SENTENCES":["#START1# #SENTENCES#", "#START1#"],
"SPTRANS":["#SUBJEKTSING# #PREDTRANSSING#", "#SUBJEKTPLUR# #PREDTRANSPLUR#"],
"FRAGEWORT":["was", "wie", "wo"],
"origin":["#PARAGRAPH##PARAGRAPH##PARAGRAPH##PARAGRAPHS##PARAGRAPHS#"],
"SATZ1":["#SPTRANS# #OBJEKT#"],
"SUBJEKTSING1N":["wort", "erkennen", "sprachspiel", "wissen", "experiment"],
"SUBJEKTSING1M":["satz", "verstand", "sinn", "mensch"],
"ADJPLUR":["eindeutige", "einzigartige", "verschiedene", "unzweifelhafte", "unmittelbare"],
"CONJ":["während", "wo", "wenn", "weshalb", "worauf"],
"SUBJEKTPLUR1":["gedanken", "farben", "sätze", "antworten", "fragen", "worte", "dinge", "fragen"],
"OBJEKTPLUR":["die sätze", "die zweifel", "die wörter"],
"OBJEKT":["#OBJEKTSING#", "#OBJEKTPLUR#"],
"START1":["#START1a#.", "#START1a#.", "#START1a#.", "#START1a#.", "#PREFIX# #START1a#.", "#PREFIXQ# #START1a#?", "#FRAGE#"],
"SUBJEKTPLUR":["#SUBJEKTPLUR1#", "#ADJPLUR# #SUBJEKTPLUR1#"],
"FRAGE":["#FRAGEPREFIX# #FRAGE1a#", "#FRAGE1a#", "#FRAGE1a#"],
"PREDINTRANSPLUR":["sprechen", "spielen", "beginnen", "lernen"],
"OBJEKTSING":["den satz", "mich", "den sinn", "den zweifel", "das spiel", "das gedächtnis"],
"PREDINTRANSSING":["spricht", "lernt", "irrt"],
"SATZ2":["#SPINTRANS#"],
"SUBJEKTSING":["#SUBJEKTSING1A#", "#SUBJEKTSING1ADJ#", "#SUBJEKTSING1A# #GENITIVSING#", "#SUBJEKTSING1ADJ# #GENITIVSING#"],
"PARAGRAPH":["#START1# #START1# #SENTENCES#\n"],
"SUBJEKTSING1A":["#ARTIKELSINGN# #SUBJEKTSING1N#", "#ARTIKELSINGM# #SUBJEKTSING1M#", "#ARTIKELSINGW# #SUBJEKTSING1W#"],
"FRAGE1a":["#FRAGEWORT# #PREDINTRANSSING# #SUBJEKTSING#?", "#FRAGEWORT# #PREDINTRANSPLUR# #SUBJEKTPLUR#?"],
"ARTIKELSINGM":["der"],
"SATZ1o2":["#SATZ1#", "#SATZ2#"],
"CONDSATZINTRANS2":["#PREDINTRANSSING# #SUBJEKTSING#", "#PREDINTRANSPLUR# #SUBJEKTPLUR#"],
"GENITIVSING1N":["wortes", "erkennens", "sprachspiels", "wissens", "kindes"],
"COUNTER":["7"],
"CONDSATZTRANS2":["#PREDTRANSSING# #SUBJEKTSING# #OBJEKTSING#", "#PREDTRANSPLUR# #SUBJEKTPLUR# #OBJEKTPLUR#"],
"GENITIVSING1M":["satzes", "verstandes", "sinns", "menschens"],
"PREFIX":["ich kann mich darin nicht irren:", "ich könnte sagen:", "wenn ich sagte:", "das heisst:", "die antwort kann auch sein:", "es ist seltsam:", "man sagt nicht:", "und dennoch:", "wir sagen:", "ich könnte auch so sagen:", "man könnte auch sagen:", "es scheint:", "das wichtigste ist hier dies:"],
"PREDTRANSSING":["sieht", "untersucht", "teilt", "liest"],
"ARTIKELSINGN":["das"],
"PARAGRAPHS":["#PARAGRAPH##PARAGRAPHS#", "#PARAGRAPH#"],
"ADJSINGDET":["unzweifelhafte", "unbeabsichtigte", "zweifelhafte", "überprüfte", "unfehlbare", "zusammenhanglose"],
"ARTIKELSINGW":["die"],
"CONDSATZTRANS":["#SUBJEKTSING# #OBJEKTSING# #PREDTRANSSING#", "#SUBJEKTPLUR# #OBJEKTPLUR# #PREDTRANSPLUR#"],
"SUBJEKTSING1W":["wahrheit", "vorstellung", "antwort", "frage", "negation", "sprachverwendung", "absicht", "erwartung", "philosophie", "frage"],
"CONDSATZ2":["#CONDSATZTRANS2#", "#CONDSATZINTRANS2#"],
"CONDSATZ":["#CONDSATZTRANS#", "#CONDSATZINTRANS#"],
"CONDSATZINTRANS":["#SUBJEKTSING# #PREDINTRANSSING#", "#SUBJEKTPLUR# #PREDINTRANSPLUR#"]
}

let strings = new LocalizedStrings({
    en:{
        title:"uncertainty",

        description:""
    },
    de: {
        title:"ungewissheit",

        description:"aus ludwig wittgensteins „über gewissheit“ werden einzelne phrasen und stilistik in einer formale generative grammatik übersetzt, die zur zufälligen erzeugung des textes verwendet wird."
    }
});

class Wittgenstein extends React.Component {
    constructor(props) {
        super(props)
        this.grammar = tracery.createGrammar(grammarDE);

        var paragraphs = []

        for (var i = 0; i < 5+Math.random()*23; i++) {
            paragraphs.push((i+1).toString()+". "+this.grammar.expand("#origin#").finishedText)
        }

        this.state = {paragraphs: paragraphs}
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
    }

    fetchMoreData = () => {
        var paragraphs = []
        for(var i = 0; i < 2; i++) {
            paragraphs.push((this.state.paragraphs.length+i+1).toString()+". "+this.grammar.expand("#origin#").finishedText)
        }

        this.setState({
            paragraphs: this.state.paragraphs.concat(paragraphs)
        });
    };

    render() {
        strings.setLanguage(this.context.language)
        return <div className="poemDisplay">
            <InfiniteScroll
              dataLength={this.state.paragraphs.length}
              next={this.fetchMoreData}
              hasMore={true}
              loader={<h4>Loading...</h4>}
            >
              {this.state.paragraphs.map((paragraph, index) => (
                <p key={index}>
                  {paragraph}
                </p>
              ))}
            </InfiniteScroll>
        </div>
    }
}
Wittgenstein.contextType = LanguageContext

export default Wittgenstein
